const colors = {
  background: "#121212",
  bannerInfo: "#226db8",
  bannerSuccess: "#3d853d",
  bannerWarning: "#c2473d",
  black: "#000000",
  blendBackground: "rgba(255,255,255,.15)",
  blue: "#add8e6",
  brightBlue: "#0000ee",
  brightRed: "#ed1c24",
  brown: "#4e3629",
  dangerForeground: "#000000",
  darkGray: "#485054",
  default: "#808080",
  divider: "#2d2d2d",
  editShortcutBackground: "#505050",
  generalText: "#e4e4e4",
  gold: "#ffc72c",
  gray: "#404040",
  green: "#008672",
  headerBackground: "#2d2d2d",
  headerText: "#e4e4e4",
  icon: "#ffffff",
  lightGray: "#ced1e0",
  lighterGray: "#f0f1f7",
  listBackground: "#1d1d1d",
  listSubtitle: "#909090",
  menuDividerBackground: "#000000",
  modalBackground: "rgba(52, 52, 52, 0.5)",
  muted: "#999999",
  navy: "#003c71",
  pink: "#e77c75",
  primary: "#687089",
  red: "#b73831",
  roleDepartment: "#505a5a",
  roleFaculty: "#9351a6",
  roleGrad: "#3C8243",
  roleMed: "#007da3",
  roleStaff: "#745c4f",
  roleUndergrad: "#a0652e",
  scrollbar: "#ffffff",
  selectedNav: "#008672",
  statusDanger: "#f48c91",
  statusMedium: "#ffe395",
  statusSuccess: "#7fdb7f",
  subHeaderBackground: "#404040",
  subTitle: "#909090",
  tabDisabled: "#808080",
  tileBackground: "#2d2d2d",
  trueRed: "#ff0000",
  webPink: "#ffc0cb",
  welcomeTag: "#e20f00",
  white: "#ffffff"
};

export default colors;
